import React, { useEffect, useState } from "react";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
} from "@mui/material";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import MDButton from "../components/MDButton";
import clientsService from "services/clientsService";
import { Client } from "./models";

type ClientResult = {
  id: number;
  name: string;
  phoneNumber: string;
  maxMiles: number;
  isBargeClient: boolean;
  isShortLine: boolean;
  isActive: boolean;
};

const ClientEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [errors, setErrors] = useState(undefined);
  const { id } = useParams();
  const [client, setClient] = useState<Client>({
      id: 0,
      name: "",
      phoneNumber: "",
      maxMiles: 0,
      isBargeClient: false,
      isShortLine: false,
      isActive: true,
    }
  );

  useEffect(()=>{
	if(!id)return;

	clientsService.getClient(id).then(r=> setClient(r));
  },[]);
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setClient({
      ...client,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
	let validation: any;
	if(!client.name || client.name.trim().length === 0)validation.name = "Name is required";
	if(!client.phoneNumber || client.phoneNumber.trim().length === 0) validation.phoneNumber = "Phone Number is required";
	if(!client.maxMiles) validation.maxMiles = "Max Miles is required";
	setErrors(validation);

	if(validation)return;

    clientsService.saveClient(client).then(r=> handleBack());
  };

  const handleBack = () => {
    if (location.key !== "default") navigate(-1);
    else navigate("/clients");
  };

  return (
    <Card sx={{ width: { xs: "100%", md: "40%" } }}>
      <CardHeader title={`Client ${client.id}`} />
      <CardContent>
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Name"
            name="name"
            value={client.name}
            onChange={handleChange}
            fullWidth
            required
			
            error={!!errors?.name}
            helperText={errors?.name}
          />

          <TextField
            label="Phone Number"
            name="phoneNumber"
            value={client.phoneNumber}
            onChange={handleChange}
            fullWidth
			required
            error={!!errors?.phoneNumber}
            helperText={errors?.phoneNumber}
          />

          <TextField
            label="Max Miles"
            name="maxMiles"
            type="number"
            value={client.maxMiles}
            onChange={handleChange}
			required
            fullWidth
            error={!!errors?.maxMiles}
            helperText={errors?.maxMiles}
          />

          <FormControlLabel
            control={<Checkbox name="isBargeClient" checked={client.isBargeClient} onChange={handleChange} />}
            label="Is Barge Client"
          />

          <FormControlLabel
            control={<Checkbox name="isShortLine" checked={client.isShortLine} onChange={handleChange} />}
            label="Is Short Line"
          />

          <FormControlLabel
            control={<Checkbox name="isActive" checked={client.isActive} onChange={handleChange} />}
            label="Is Active"
          />
          <Box component="div" sx={{ display: "inline-flex", justifyContent: "end" }}>
            <MDButton onClick={handleBack}>Cancel</MDButton>
            <MDButton type="submit" variant="contained" color="dark">
              Save
            </MDButton>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ClientEdit;
